export default {
  async fetchTwoFaStatus({ commit }) {
    commit("setLoading", true);
    try {
      const res = await fetch("/api/auth/2fa/status", {
        method: "GET",
        credentials: "include",
      });
      const data = await res.json();

      commit("setTwoFaStatus", data.isTwoFaEnabled || false);
      return { success: true, data };
    } catch (error) {
      console.error("Error fetching 2FA status:", error);
      commit("setMessage", "Failed to fetch 2FA status.");
      return { success: false };
    } finally {
      commit("setLoading", false);
    }
  },

  // ✅ Generate 2FA QR + Secret
  async generateTwoFa({ commit }) {
    commit("setLoading", true);
    try {
      const res = await fetch("/api/auth/2fa/setup", {
        method: "Post",
        credentials: "include",
      });
      const data = await res.json();

       commit("setQrCode", data.qrDataUrl);
    commit("setSecretKey", data.secret);

    return { success: true, qrCodeDataUrl: data.qrDataUrl, secretKey: data.secret };
    } catch (error) {
      console.error("Error generating 2FA:", error);
      commit("setMessage", "Failed to generate 2FA setup.");
      return { success: false };
    } finally {
      commit("setLoading", false);
    }
  },

  // ✅ Verify & Enable 2FA
   async verifyTwoFa({ commit }, payload) {
    commit("setLoading", true);
    try {
      const res = await fetch("/api/auth/2fa/verify-enable", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ code: payload.token }), 
      });

      const data = await res.json();

      if (data.success) {
        commit("setTwoFaStatus", true);
        commit("setMessage", "Two-factor authentication enabled successfully!");
        commit("resetQrData");
      } else {
        commit("setMessage", data.message || "Invalid or expired code.");
      }

      return data;
    } catch (error) {
      console.error("Error verifying 2FA:", error);
      commit("setMessage", "Failed to verify 2FA.");
      return { success: false };
    } finally {
      commit("setLoading", false);
    }
  },

  // ✅ Disable 2FA
async disableTwoFa({ commit }, payload) {
    commit("setLoading", true);
    try {
      const res = await fetch("/api/auth/2fa/disable", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ code: payload.token }), // ✅ backend expects "code"
      });

      const data = await res.json();

      if (data.success) {
        commit("setTwoFaStatus", false);
        commit("setMessage", "Two-factor authentication disabled successfully.");
      } else {
        commit("setMessage", data.message || "Invalid or expired code.");
      }

      return data;
    } catch (error) {
      console.error("Error disabling 2FA:", error);
      commit("setMessage", "Failed to disable 2FA.");
      return { success: false };
    } finally {
      commit("setLoading", false);
    }
  },
};
